import { render, staticRenderFns } from "./MemberTransactionsDetail.vue?vue&type=template&id=1f42f8fe&scoped=true"
import script from "./MemberTransactionsDetail.vue?vue&type=script&lang=js"
export * from "./MemberTransactionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42f8fe",
  null
  
)

export default component.exports